import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="observability--attempt-toggle"
// Accordion toggle for attempt timeline rows in the jobs show page.
// Clicking an attempt row expands its timeline; any other open timeline closes.
export default class extends Controller {
  static targets = ["row", "timeline", "chevron"]

  toggle(event) {
    const row = event.currentTarget
    const id = row.dataset.timelineId
    if (!id) return

    const target = document.getElementById(id)
    if (!target) return

    // Close any other open timeline (accordion behavior)
    this.timelineTargets.forEach((tl) => {
      if (tl.id !== id && !tl.classList.contains("hidden")) {
        tl.classList.add("hidden")
        const otherChevron = this.chevronTargets.find(
          (c) => c.dataset.timelineId === tl.id,
        )
        if (otherChevron) otherChevron.style.transform = ""
      }
    })

    // Toggle this one
    const isHidden = target.classList.toggle("hidden")
    const chevron = this.chevronTargets.find((c) => c.dataset.timelineId === id)
    if (chevron) chevron.style.transform = isHidden ? "" : "rotate(90deg)"
  }
}
